module.exports = __webpack_public_path__ + "static/media/detect.fd010bb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/components/IntroSection/detect.png
// module id = 604
// module chunks = 0